import React, { Fragment, useEffect, useRef, useState } from "react";
import Chart from "chart.js/auto";
import Select from "react-select";
import "./AllTreeMortality.css";

import {
  getAllYearsRpt,
  getPestSummaryMortalityAcres,
  getPestSummaryOtherAcres,
  getPestSummarySurveyedAcres,
} from "../../services/pestTableService";





function getMortalityData(selYear) {
  const filter = { years: [selYear], damageTypeId: 92 };
  const filterAll = { years: [selYear], damageTypeId: 93 };
  return Promise.all([
    getPestSummaryMortalityAcres(filter),
    getPestSummaryOtherAcres(filterAll),
    getPestSummarySurveyedAcres(filterAll),
  ]);
}





function AllTreeMortality() {
  const [dataLoaded, setDataLoaded] = useState(false);
  const [selectedYear, setSelectedYear] = useState();
  const [mortalityAcres, setMortalityAcres] = useState();
  const [otherAcres, setOtherAcres] = useState();
  const [chartVersion, setChartVersion] = useState(true);
  const years = useRef([
    {
      value: 2023,
      label: "2023",
      isDisabled: false,
    },
  ]);
  const chart1 = useRef();
  const chartRef1 = useRef(null);
  const tAcresY1 = useRef("");
  const tAcresY2 = useRef("");
  const tAcresY3 = useRef("");
  const tAcresY4 = useRef("");
  const tAcresY5 = useRef("");
  const tAcresN1 = useRef("");
  const tAcresN2 = useRef("");
  const tAcresN3 = useRef("");
  const tAcresN4 = useRef("");
  const tAcresN5 = useRef("");
  const surveyAreaMax = useRef(600);
  const acresMax = useRef(12);
  const oAcres = useRef([0, 0, 0, 0, 0]);
  const config1 = useRef();

  // Initial load
  useEffect(() => {
    createTreeMortalityChart();
    getAllYearsRpt().then((result) => {
      const years1 = result.data;
      years.current = years1.slice(0, 5);
      setSelectedYear(years.current[0]);
    });
  }, []);

  // When selected year changes
  useEffect(() => {
    if (selectedYear) {
      getMortalityData(selectedYear.value)
        .then(([mort, mortAll, othAll]) => {
          const rchartMortality = mort.data;
          const allTreeDamage = mortAll.data;
          const allSurveyed = othAll.data;

          let mortality = (rchartMortality.data[0]?.fAcres.toString()) ?? "0";
          mortality = mortality + " million";

          let other = (allTreeDamage.data[0]?.Acres.toString()) ?? "0";
          other =
            other.substring(0, other.length - 6) +
            "." +
            other.substring(other.length - 6, other.length - 5) +
            " million";

          setMortalityAcres(mortality);
          setOtherAcres(other);

          tAcresY1.current = "NA";
          tAcresY2.current = "NA";
          tAcresY3.current = "NA";
          tAcresY4.current = "NA";
          tAcresY5.current = "NA";

          tAcresN1.current = 0;
          tAcresN2.current = 0;
          tAcresN3.current = 0;
          tAcresN4.current = 0;
          tAcresN5.current = 0;

          oAcres.current = 0;

          tAcresY1.current = rchartMortality.data[0]?.Year ?? "NA";
          tAcresY2.current = rchartMortality.data[1]?.Year ?? "NA";
          tAcresY3.current = rchartMortality.data[2]?.Year ?? "NA";
          tAcresY4.current = rchartMortality.data[3]?.Year ?? "NA";
          tAcresY5.current = rchartMortality.data[4]?.Year ?? "NA";

          tAcresN1.current = ((rchartMortality.data[0]?.Acres ?? 0) / 1000000).toPrecision(2);
          tAcresN2.current = ((rchartMortality.data[1]?.Acres ?? 0) / 1000000).toPrecision(2);
          tAcresN3.current = ((rchartMortality.data[2]?.Acres ?? 0) / 1000000).toPrecision(2);
          tAcresN4.current = ((rchartMortality.data[3]?.Acres ?? 0) / 1000000).toPrecision(2);
          tAcresN5.current = ((rchartMortality.data[4]?.Acres ?? 0) / 1000000).toPrecision(2);

          oAcres.current = [
            (allSurveyed.data[4].Acres / 1000000).toPrecision(2),
            (allSurveyed.data[3].Acres / 1000000).toPrecision(2),
            (allSurveyed.data[2].Acres / 1000000).toPrecision(2),
            (allSurveyed.data[1].Acres / 1000000).toPrecision(2),
            (allSurveyed.data[0].Acres / 1000000).toPrecision(2),
          ];

          // Get maximum values for chart axes
          acresMax.current = Math.max(
            tAcresN1.current,
            tAcresN2.current,
            tAcresN3.current,
            tAcresN4.current,
            tAcresN5.current
          );
          surveyAreaMax.current =
            Math.round(
              Math.max(
                allSurveyed.data[4].Acres,
                allSurveyed.data[3].Acres,
                allSurveyed.data[2].Acres,
                allSurveyed.data[1].Acres,
                allSurveyed.data[0].Acres
              ) / 100000000
            ) * 100;

          // Add a buffer
          surveyAreaMax.current = surveyAreaMax.current + 100;
          acresMax.current = acresMax.current + 2;

          // Match up ticks for both axes
          if (acresMax.current * 50 > surveyAreaMax.current) {
            surveyAreaMax.current = acresMax.current * 50;
          } else {
            acresMax.current = surveyAreaMax.current / 50;
          }

          config1.current.data.labels = [
            tAcresY5.current,
            tAcresY4.current,
            tAcresY3.current,
            tAcresY2.current,
            tAcresY1.current,
          ];
          config1.current.data.datasets[0].data = [
            tAcresN5.current,
            tAcresN4.current,
            tAcresN3.current,
            tAcresN2.current,
            tAcresN1.current,
          ];

          config1.current.data.datasets[1].data = oAcres.current;
          // Update axes maximums dynamically
          config1.current.options.scales.A.max = acresMax.current;
          config1.current.options.scales.A.ticks.max = acresMax.current;
          config1.current.options.scales.B.max = surveyAreaMax.current;
          config1.current.options.scales.B.ticks.max = surveyAreaMax.current;
          chart1.current.update();
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, [selectedYear]);



  const createTreeMortalityChart = () => {
    const canv = document.getElementById("trend-chart");
    const ctx = canv.getContext("2d");
    config1.current = {
      type: "bar",
      data: {
        //Bring in data
        labels: [
          tAcresY5.current,
          tAcresY4.current,
          tAcresY3.current,
          tAcresY2.current,
          tAcresY1.current,
        ],
        datasets: [
          {
            label: "Acres (million)",
            backgroundColor: "#7F9563",
            borderColor: "#7F9563",
            yAxisID: "A",
            order: 2,
            data: [
              tAcresN5.current,
              tAcresN4.current,
              tAcresN3.current,
              tAcresN2.current,
              tAcresN1.current,
            ],
          },
          {
            label: "Surveyed Area (million)",
            data: oAcres.current,
            fill: false,
            backgroundColor: "#595959",
            borderColor: "#595959",
            tension: 0.4,
            yAxisID: "B",
            order: 1,
            // Changes this dataset to become a line
            type: "line",
          },
        ],
      },
      options: {
        //Customize chart options
        scales: {
          A: {
            id: "A",
            type: "linear",
            beginAtZero: true,
            position: "left",
            max: acresMax.current,
            ticks: {
              stepSize: 2,
              max: acresMax.current,
              min: 0,
            },
          },
          B: {
            id: "B",
            type: "linear",
            beginAtZero: true,
            position: "right",
            max: surveyAreaMax.current,
            ticks: {
              stepSize: 100,
              max: surveyAreaMax.current,
              min: 0,
            },
          },
        },
        plugins: {
          tooltip: {
            enabled: true,
          },
        },
      },
    };

    if (chart1.current) {
      chart1.current.destroy();
    }
    chart1.current = new Chart(ctx, config1.current);
    setDataLoaded(true);
  };

  return (
    <div className="all-tree-mortality">
      <div className="grid-row">
        <h2>All Tree Mortality - Results by Survey Year</h2>
      </div>
      <div className="grid-row national-reports-section">
        <div
          className="loading-box tablet:grid-col-12 mobile-lg:grid-col-12"
          style={{ display: dataLoaded ? "none" : "flex" }}
        >
          <br />
          <div className="spinner" />
        </div>
        <div className="select-year-column tablet:grid-col-2 mobile-lg:grid-col-12">
          {dataLoaded && (
            <Fragment>
              <label id="year-label" htmlFor="select-survey-year">
                Select Year
              </label>
              <Select
                id="select-survey-year"
                className="react-select select-year"
                placeholder="Select Year"
                aria-label="Select a year. Press the down arrow to expand the option list. Press delete
                to clear the current selection."
                name="singleSelect"
                value={selectedYear}
                onChange={(value) => setSelectedYear(value)}
                options={years.current}
                hideselectedoptions="true"
              />
            </Fragment>
          )}
        </div>
        <div className="national-stats-column tablet:grid-col-3 text-center mobile-lg:grid-col-12">
          {dataLoaded && selectedYear && mortalityAcres && otherAcres && (
            <div className="national-stats">
              <div
                aria-live="polite"
                aria-atomic="true"
                className="stat-section text-center"
              >
                <div className="stat-section-header">Year</div>
                <div className="stat-section-value">
                  {selectedYear ? selectedYear.value : ""}
                </div>
              </div>
              <div
                aria-live="polite"
                aria-atomic="true"
                className="stat-section text-center"
              >
                <div className="stat-section-header">With Dead Trees</div>
                <div className="stat-section-value">{mortalityAcres} acres</div>
              </div>
              <div
                aria-live="polite"
                aria-atomic="true"
                className="stat-section text-center"
              >
                <div className="stat-section-header">All Tree Damage</div>
                <div className="stat-section-value">{otherAcres} acres</div>
              </div>
            </div>
          )}
        </div>
        <div className="chart-column tablet:grid-col-7 text-center mobile-lg:grid-col-12">
          <div className="chart-type-buttons">
            <button
              onClick={() => {
                setChartVersion(true);
              }}
              className={"first " + (chartVersion ? "selected" : "unselected")}
              aria-label="Select chart version of trend data"
            >
              Chart version
            </button>
            <button
              onClick={() => {
                setChartVersion(false);
              }}
              className={chartVersion ? "unselected" : "selected"}
              aria-label="Select tabular version of trend data"
            >
              Tabular version
            </button>
          </div>
          <div
            className="chart-table-region"
            aria-live="polite"
            aria-atomic="true"
          >
            <b>
              National tree mortality trend {chartVersion ? "chart" : "table"}
            </b>
            <canvas
              id="trend-chart"
              aria-label="National tree mortality trend chart"
              data-testid="trend-chart"
              ref={chartRef1}
              tabIndex="0"
              className={chartVersion ? "visible" : "hidden"}
            >
              Select Tabular version button to display chart data in tabular
              form
            </canvas>
            <table
              aria-label="National tree mortality trend table"
              className={
                "usa-table pest-trend-table " +
                (chartVersion ? "hidden" : "visible")
              }
            >
              <thead>
                <tr>
                  <th scope="col" aria-label="Year">
                    Year
                  </th>
                  <th
                    scope="col"
                    aria-label="National tree mortality in millions of acres"
                  >
                    National tree mortality
                    <br />
                    (million acres)
                  </th>
                  <th
                    scope="col"
                    aria-label="Surveyed area in millions of acres"
                  >
                    Surveyed area
                    <br />
                    (million acres)
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{tAcresY5.current}</td>
                  <td>{tAcresN5.current}</td>
                  <td>{(oAcres.current[0] * 1000000) / 1000000}</td>
                </tr>
                <tr>
                  <td>{tAcresY4.current}</td>
                  <td>{tAcresN4.current}</td>
                  <td>{(oAcres.current[1] * 1000000) / 1000000}</td>
                </tr>
                <tr>
                  <td>{tAcresY3.current}</td>
                  <td>{tAcresN3.current}</td>
                  <td>{(oAcres.current[2] * 1000000) / 1000000}</td>
                </tr>
                <tr>
                  <td>{tAcresY2.current}</td>
                  <td>{tAcresN2.current}</td>
                  <td>{(oAcres.current[3] * 1000000) / 1000000}</td>
                </tr>
                <tr>
                  <td>{tAcresY1.current}</td>
                  <td>{tAcresN1.current}</td>
                  <td>{(oAcres.current[4] * 1000000) / 1000000}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="grid-row">
        <p>
          Total acres with mortality from forest health damage detection surveys
          are summarized from current year's observations only and are not
          cumulative.
        </p>
        <p>
          Insect and disease surveys for 2020 were impacted by COVID-19 and some
          regions and states were unable to conduct typical surveys. Therefore,
          other remote sensing products and additional ground surveys were used
          to supplement data gathered by aerial surveys. Overall, there was a
          50% reduction in acres surveyed this year with only 215M acres in
          2020; down from 500M acres surveyed in 2019.
        </p>
      </div>
    </div>
  );
}

export default AllTreeMortality;
